<template>
    <dashboard-criticality-card
        title="Ehliyet"
        :fields="fields"
        :provider="provider"
        :enabled-levels="enabledLevels"
        excel-file-name="Ehliyet" />
</template>

<script>
import DriverLicenseApi from "@/api/driver-license";
import DashboardCriticalityCard from "./DashboardCriticalityCard.vue";

export default {
    components: { DashboardCriticalityCard },
    props: {
        enabledLevels: { type: Array, default: null },
    },
    data() {
        return {
            fields: [
                { name: "Personel", key: "EmployeeFullName" },
                { name: "Sicil No", key: "RegistrationCode" },
                { name: "Yaka", key: "CollarStatusName" },
                { name: "Başlangıç Tarihi", key: "ValidityStartDateStr" },
                { name: "Bitiş Tarihi", key: "ValidityEndDateStr" },
                { name: "Kalan Gün", key: "RemainingDate" },
            ],
        };
    },
    methods: {
        provider() {
            return DriverLicenseApi.DriverLicenseDashboard();
        },
    },
};
</script>
